export const colors = {
    azul    : '#443671',
    azul2   : '#080035',
    naranja : '#FF6720',
}
export const transition = 'var(--transition)';